/* eslint-disable */
import React, { Component } from 'react'
import TextInput from '../inputs/TextInput';
import FormSearchInput from '../inputs/FormSearchInput';
import SearchInput from '../inputs/SearchInput';
import { IoMdClose } from 'react-icons/io';
import TextareaInput from '../inputs/TextareaInput';
import { HiOutlineUpload } from "react-icons/hi";

class AssetProfilerFormModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fileMessage: " Upload Asset(s) picture",
        }
    }


    fileData = () => {

        if (this.state.selectedFile) {

            return (
                <div>
                    <br />
                    <a href="#">
                        <p style={{ color: "#000000", fontSize: "14px" }}>File Name: {this.state.selectedFile.name}
                            <GiTrashCan style={{ cursor: "pointer" }} onClick={this.handleDeleteFile} />
                        </p>
                    </a>

                </div>
            );
        } else {
            return (
                <div>
                    <br />
                    <span style={{ color: "red" }}>Supported docs! (PDF, WORD, EXCEL & JPG)</span>
                </div>
            );
        }
    };
    render() {
        return (<>
            <div
                className='overlay'
                style={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0px 2px 6px #0000000A',
                }}>
                <div className='flex flex-v-center flex-h-center flex-direction-column'>
                    <div
                        className='modal-box'
                        style={{
                            boxShadow: '0px 2px 6px #0000000A',
                            position: 'relative',
                            width: '980px',
                        }}>
                        <div className='content no-padding '>
                            <IoMdClose
                                className='pointer m-l-5'
                                style={{
                                    position: 'absolute',
                                    top: '0',
                                    left: '100%',
                                    fontSize: '24px',
                                    color: '#fff',
                                    width: '40px',
                                    height: '40px',
                                    backgroundColor: '#F74F11',
                                    padding: '3px',
                                }}
                                onClick={this.props.closeModal}
                            />
                            <div className={`w-100 ${this.props.className}`}>
                                <div
                                    className='w-100 flex space-between'
                                    style={{ padding: '15px', backgroundColor: '#d5ffd5' }}>
                                    <p>Asset Profiler</p>
                                </div>

                                <div className='col-4 '>
                                    <label className="custom-file-upload " style={{ backgroundColor: "#EFD66BF2", color: "black" }}>
                                        <input type="file" className="w-100 m-b-10 custom-file-upload"
                                            name="file"
                                            multiple
                                            onChange={this.onFileChange} />
                                        <HiOutlineUpload />
                                        {this.state.fileMessage}

                                    </label>
                                    {/* {this.fileData()} */}
                                </div>

                                <div className="col-8">

                                    <div class='form-group'>
                                        <div class='row '>
                                            <div class='col-8 m-t-10'>
                                                <TextInput
                                                    className='w-100 m-b-10'
                                                    name='cost'
                                                    label='Item name'
                                                    value={this.state.cost}
                                                    type='number'
                                                    onChange={(e) => this.handleChange(e)}
                                                    color='rgba(112,112,112,.7)'
                                                />
                                            </div>
                                            <div class='col-4 m-t-10'>
                                                <TextInput
                                                    className='w-100 m-b-10'
                                                    name='cost'
                                                    label='Category'
                                                    value={this.state.cost}
                                                    type='number'
                                                    onChange={(e) => this.handleChange(e)}
                                                    color='rgba(112,112,112,.7)'
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div class='form-group'>
                                        <div class='row '>
                                            <div class='col-6 m-t-10'>
                                                <TextInput
                                                    className='w-100 m-b-10'
                                                    name='cost'
                                                    label='Manufacturer'
                                                    value={this.state.cost}
                                                    type='number'
                                                    onChange={(e) => this.handleChange(e)}
                                                    color='rgba(112,112,112,.7)'
                                                />
                                            </div>
                                            <div class='col-3 m-t-10'>
                                                <TextInput
                                                    className='w-100 m-b-10'
                                                    name='cost'
                                                    label='Supplier'
                                                    value={this.state.cost}
                                                    type='number'
                                                    onChange={(e) => this.handleChange(e)}
                                                    color='rgba(112,112,112,.7)'
                                                />
                                            </div>
                                            <div class='col-3 m-t-10'>
                                                <TextInput
                                                    className='w-100 m-b-10'
                                                    name='cost'
                                                    label='Unit Cost'
                                                    value={this.state.cost}
                                                    type='number'
                                                    onChange={(e) => this.handleChange(e)}
                                                    color='rgba(112,112,112,.7)'
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class='form-group'>
                                        <div class='row '>
                                            <div class='col-6 m-t-10'>
                                                <TextInput
                                                    className='w-100 m-b-10'
                                                    name='cost'
                                                    label='Product Serial Number'
                                                    value={this.state.cost}
                                                    type='number'
                                                    onChange={(e) => this.handleChange(e)}
                                                    color='rgba(112,112,112,.7)'
                                                />
                                            </div>
                                            <div class='col-3 m-t-10'>
                                                <TextInput
                                                    className='w-100 m-b-10'
                                                    name='cost'
                                                    label='Delivery Date'
                                                    value={this.state.cost}
                                                    type='number'
                                                    onChange={(e) => this.handleChange(e)}
                                                    color='rgba(112,112,112,.7)'
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class='form-group'>
                                        <div class='row '>
                                            <div class='col-12 m-t-10'>
                                                <TextareaInput
                                                    className='w-100 m-b-10'
                                                    name='cost'
                                                    label='Item Description'
                                                    value={this.state.cost}
                                                    type='number'
                                                    onChange={(e) => this.handleChange(e)}
                                                    color='rgba(112,112,112,.7)'
                                                />
                                            </div>

                                        </div>
                                    </div>


                                    <div className='w-100 m-t-10 flex flex-v-center flex-h-center space-between'>
                                        <button className='btn btn-large w-49' style={{backgroundColor:'#43425D'}} type='button' onClick={this.onSubmit}>
                                            Save Request
                                        </button>
                                        <button
                                            className='btn btn-large w-49'
                                            type='button'
                                            onClick={this.handleSubmitFormRequest}>
                                            Submit Request
                                        </button>
                                    </div>
                               
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
       
        </>);
    }
}

export default AssetProfilerFormModal;